import React, { useState, useEffect } from "react";
import './Products.css'

const Services = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    // Fetch products
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch("https://admin.granasialife.com/api/products");
      const data = await response.json();
      setProducts(data.data);
      setLoading(false); // Set loading to false when data is fetched
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <div className="services-container">
      <div className="services-content">
        <h2 className="text-center blue-color">
          <i className="fas fa-flask"></i> OUR MAIN PRODUCTS
        </h2>
        <p className="text-center fs-5">
          Human care is more than healthcare. We prefer quality over anything.
        </p>
        {loading ? ( // Display loader while loading
          <div className="text-center">
            <div className="spinner-border" role="status"></div>
            <br />
            Loading Products...
          </div>
        ) : (
          <div className="container">
            <div className="row g-3">
              {/* Render products */}
              {products.map((product) => (
                <div key={product.id} className="col-md-4">
                  <div className="card h-100"> {/* Ensure all cards have the same size */}
                  <img 
                  src={product.image_url.startsWith('http') ? product.image_url : `https://granasialife.com${product.image_url}`} 
                  alt={product.name} 
                />
                
                    <div className="card-body">
                      <h5 className="card-title">{product.name}</h5>
                      <p className="card-text">CONTAINS: {product.contains}.</p>
                      <p className="card-text">INDICATIONS: {product.indications}</p>
                      <p className="card-text">MRP: {product.mrp}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
